import { TeamHandle } from "resource-planner-model";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { createSelector } from "reselect";
import { AppState } from "../redux/AppTypes";
import { createTeamsSelector } from "./useTeams";

export const createSortedTeamsSelector = () =>
  createSelector(createTeamsSelector(), (items) => {
    const sortedItems = Object.values(items);
    sortedItems.sort((i1, i2) => i1.compare(i2));
    return sortedItems;
  });

export default function useSortedTeams(year: number, month: number): TeamHandle[] {
  const selector = useMemo(createSortedTeamsSelector, []);
  return useSelector((state: AppState) => selector(state, year, month));
}
